import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { space, getWidth, getHeight } from '../../mixins';

import * as icons from './iconsConfig';

const StyledSvg = styled.svg`
  fill: ${props => {
    if (props.disabled) {
      return '#cdcdcd';
    }

    return props.theme.colors[props.color] || props.color || '#0464FF';
  }};
  ${space};
  ${getWidth};
  ${getHeight};
`;

class InlineIcon extends React.Component {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    width: PropTypes.string,
    height: PropTypes.string,
    color: PropTypes.string
  };

  static defaultProps = {
    disabled: false,
    width: '16px',
    height: '16px',
    color: null
  };

  render() {
    const { icon, ...restProps } = this.props;

    if (!icons[icon]) return null;

    return (
      <StyledSvg {...restProps}>
        <use xlinkHref={`#${icon}`} />
      </StyledSvg>
    );
  }
}

export default InlineIcon;



// WEBPACK FOOTER //
// ./src/components/units/Icon/Icon.js